export default __webpack_public_path__ + "static/media/light_logo.0d113616.png";